import styled, { css } from 'styled-components';
import { mediaQuery } from '../../utils';
import { TextBoxSubTitle } from '../TextBox'; // TODO: https://github.com/salute-developers/plasma/issues/232

/**
 * Компонент для размещения подзаголовка.
 */

import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Header/HeaderSubtitle');
export var HeaderSubtitle = /*#__PURE__*/styled(TextBoxSubTitle).withConfig({
  componentId: "plasma-ui__sc-hdcqcu-0"
})(["margin:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;", ""], function (_ref) {
  var theme = _ref.theme;
  return css(["", ""], mediaQuery('S', theme.deviceScale)(css(["display:none;"])));
});